import {
  DocumentEditor,
  DocumentEditorProps,
} from "@onlyoffice/document-editor-react";
import { useId } from "react";

export function OnlyOfficeEditor({
  id,
  ...props
}: Omit<DocumentEditorProps, "id"> & { id?: string }) {
  const generatedId = useId();

  return (
    <div className={"h-full"}>
      <DocumentEditor id={id || generatedId} {...props} />
    </div>
  );
}
